import { DEMO_CONNECTION_INDEX, getPortalSdk } from 'portal-sdk';
import { UseQueryOptions, useQuery } from 'react-query';

import { isOnPremise } from 'bones/utils/portal/environment';

export type PortalConnection = NonNullable<
  Awaited<
    ReturnType<
      NonNullable<ReturnType<typeof getPortalSdk>>['getConnectionByIndex']
    >
  >
>;

export const usePortalConnectionByIndex = (
  connectionIdx: number,
  options?: UseQueryOptions<PortalConnection | null>
) =>
  useQuery<PortalConnection | null>(
    `usePortalConnectionByIndex-${connectionIdx}`,
    async () => {
      // Don't get the demo connection for Launchpad
      if (isOnPremise() && connectionIdx === DEMO_CONNECTION_INDEX) {
        return null;
      }

      const sdk = getPortalSdk();
      if (!sdk) {
        throw new Error('!sdk');
      }

      const connection = await sdk.getConnectionByIndex(connectionIdx);
      return connection;
    },
    options
  );
